import { SerializedNodes } from '@craftjs/core';
import { BaseScoreSection, BaseVariableSection } from 'src/services/api/api-client';
import { createContext } from 'use-context-selector';

export enum ValidationEnum {
  DataKey,
  OptionWeight,
  NoAnswerScore,
  SliderMarks,
  ScoreSection,
  NoFileTypes,
  ConditionalExpression,
}

export type ValidationResultType = {
  [nodeId: string]: { type: ValidationEnum; message: string } | undefined;
};

export type LayoutValidationContextType = {
  layout?: SerializedNodes;
  scoreSections?: BaseScoreSection[];
  variables?: BaseVariableSection[];
  layoutValidationResult: ValidationResultType;
  scoreValidationResult: ValidationResultType;
  triggerScoreValidation?: () => ValidationResultType | undefined;
};

const defaultValues: LayoutValidationContextType = {
  layoutValidationResult: {},
  scoreValidationResult: {},
};

export const LayoutValidationContext = createContext(defaultValues);
